import { Component, OnInit, Input } from '@angular/core';
import { ResourceAPIService } from '../resource/resource.service';
import { UserInfoService } from '../user/user-info.service';

@Component({
	selector: 'app-edit-resource-description',
	templateUrl: `./edit-resource-description.component.html`,
	styleUrls: ['./territory-card.scss'],
	standalone: false
})
export class EditResourceDescriptionComponent implements OnInit {

	@Input() description: string = "";
	@Input() resourceId: string = "";
	@Input() resourcePersonId: string = "";	

	constructor(
		private resourceAPIService: ResourceAPIService,
		private userInfoService: UserInfoService
	) { }

	isEditMode: boolean = false;
	showFullText: boolean = false;
	numTextSlice: number = 255;
	numMaxChars: number = 2000;
	descriptionBeforeEdit: string = "";
	currentUserPersonId: string = "";

	handleArrowKeys(event: KeyboardEvent) {
		const isArrowKey =
			event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'ArrowLeft' || event.key === 'ArrowRight';

		if (isArrowKey) {
			// Prevent focus from leaving the textarea
			event.stopPropagation();
		}
	}

	onCancel() {
		this.description = this.descriptionBeforeEdit;
		this.isEditMode = false;		
	}

	onEdit() {
		this.descriptionBeforeEdit = this.description;
		this.isEditMode = !this.isEditMode;
	}

	onSave() {		
		this.resourceAPIService.updateUserResourceDescription(this.resourceId, this.description, this.resourcePersonId).subscribe(
			(response) => {
				console.log(response);
				this.isEditMode = false;
			},
			(error) => {
				console.log(error);
				this.description = this.descriptionBeforeEdit;
				this.isEditMode = false;
			}
		);
	}

	ngOnInit(): void {
		this.currentUserPersonId = this.userInfoService.getProfile().PersonId;	
	}
}
